import { FaStar, FaStarHalfAlt, FaHeart, FaArrowRight } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import StarIcon from '@mui/icons-material/Star';



const ShopCard = ({ laundry }) => {
  const isImageAvailable = !!laundry?.image;
      const isOpen = laundry?.time?.open && laundry?.time?.close;


  return (
  <div className="flex flex-row  items-center bg-white border border-[#D8DAE5] rounded-2xl p-3 relative overflow-hidden space-x-3 lg:space-x-0">

  {/* Image wrapper */}
  <div className="relative  w-[200px]  md:w-[250px]" >
    <div className="w-full h-32  bg-[#E8F3F8] rounded-xl overflow-hidden ">
      {isImageAvailable ? (
        <img
          src={laundry.image}
          alt="Laundry"
          className="w-full h-full object-cover"
        />
      ) : (
        <LocalLaundryServiceIcon
          style={{ fontSize: 80 }}
          className="text-[#3383B2] mx-auto my-auto"
        />
      )}
    </div>

    {laundry?.preferred && (
      <div className="absolute bottom-4 right-2 bg-[var(--card-verified-bg)] text-xs sm:text-sm rounded-[6px] px-2 py-1 flex items-center gap-1 shadow-sm backdrop-blur-lg">
        <MdVerified className="text-[var(--card-verified-icon)] font-bold text-sm sm:text-sm" />
        <span className="text-[var(--card-verified-text)] font-medium">
          TYDII
        </span>
      </div>
    )}
  </div>

  {/* Title + rating */}
  <div className="pl-2 sm:pl-8 lgs:pl-4 lg:pl-8">
     <h5 className="font-medium text-sm text-[#767777] text-start ">
      Laundry Name 
    </h5>
    <h5 className="font-semibold text-lg text-[#063853] text-start  mb-2">
      {laundry?.title} 
    </h5>

    <div className="flex justify-start  gap-1 items-center text-base mb-2">
      {[...Array(5)].map((_, i) => (
        <StarIcon
          key={i}
          fontSize="small"
          sx={{
            color: i < laundry?.rating ? "var(--card-rating)" : "#e5e7eb",
          }}
        />
      ))}
    </div>
      {/* Time Slot */}
  <div className=" bg-[#EBF9FF] text-[#767777] text-sm font-[600] w-fit  px-3 py-1 rounded-lg ">
    {isOpen ? `${laundry.time.open} - ${laundry.time.close}` : "Opens Soon"}
  </div>
  </div>


</div>

  );
};

export default ShopCard;
